import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import * as React from 'react';

export function SvgLock() {
  return <LockLockedIcon label="" testId="ads-refreshed-icon" />;
}
